import type { PointData } from 'pixi.js';
import smallBurstFXJSON from '../../../../../../assets/particles{ignore}/Diorama_Burst_Particles_1.json';
import type { FXParticleEmitterConfig } from '../../../../../libs/particles/FXParticleEmitterConfig';
import largeBurstFXJSON from '../../../../../../assets/particles{ignore}/Diorama_Burst_Particles_2.json';
import type { FXParticleLayer } from '../../../../../libs/particles/FXParticleLayer';

export function showDioramaCompleteFX(particleLayer: FXParticleLayer, center: PointData): void {
  const smallBurstConfig = smallBurstFXJSON as FXParticleEmitterConfig;
  const largeBurstConfig = largeBurstFXJSON as FXParticleEmitterConfig;

  [
    {
      x: 0,
      y: -100,
      emitterConfig: largeBurstConfig,
    },
    {
      x: -200,
      y: -400,
      emitterConfig: {
        ...smallBurstConfig,
        startDelay: 1000,
      },
    },
    {
      x: 200,
      y: -450,
      emitterConfig: {
        ...smallBurstConfig,
        startDelay: 1200,
      },
    },
  ].forEach(({ x, y, emitterConfig }) => {
    particleLayer.addParticleEmitter(center.x + x, center.y + y, emitterConfig);
  });
}
